<!-- -->
<template>
  <div>
    <div class="basicMessageBox">
      <div
        v-for="(item, index) in form_arr"
        :key="index"
        :id="form_arr.length + index"
      >
        <span style="color: red" class="necessary">{{
          item.type.n == true ? "*" : ""
        }}</span>
        <span :id="index" class="spanTitle">{{ item.title }}</span>

        <span :id="item.getMsg" v-if="item.type.t == 0" class="spanMsg">{{
          item.msg
        }}</span>

        <el-input
          :id="item.getMsg"
          clearable
          :disabled="item.type.d"
          size="small"
          v-model="item.msg"
          v-else-if="item.type.t == 1"
          @change="outPutFnc(item.getMsg)"
        ></el-input>

        <el-select
          :id="item.getMsg"
          :popper-append-to-body="false"
          :append-to-body="false"
          v-model="item.msg"
          size="small"
          filterable
          :disabled="item.type.d"
          clearable
          v-else-if="item.type.t == 2"
          @change="outPutFnc(item.getMsg)"
        >
          <el-option
            v-for="itemObj in option_list[item.getMsg].options"
            :key="itemObj[option_list[item.getMsg].key]"
            :label="itemObj[option_list[item.getMsg].label]"
            :value="itemObj[option_list[item.getMsg].value]"
          >
          </el-option>
        </el-select>

        <el-date-picker
          :id="item.getMsg"
          v-else-if="item.type.t == 3"
          :disabled="item.type.d"
          size="small"
          v-model="item.msg"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          @change="outPutFnc(item.getMsg)"
          placeholder="请选择时间"
        >
        </el-date-picker>

        <img
          src="../../assets/images/boda.png"
          class="imghover"
          @click="call(item.msg)"
          v-if="item.title.indexOf('联系电话') != -1"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo2")), //本地缓存
      outPutObj: {}, // 组件抛出的数据
      messageList: {},
    };
  },
  methods: {
    /**
     * 软电话呼叫
     */
    call(phone) {
      var obj = {};
      if (phone == "" || phone == null || phone == undefined) {
        this.$message({
          type: "error",
          message: "联系号码空号！",
        });
        return;
      } else {
        obj.brandId = this.userInfo.data.brand;
        obj.tempPhone = phone;
      }
      this.$bus.$emit("dh", obj);
    },
    /**
     * 子组件传参父组件处理
     */
    outPutFnc(col) {
      this.outPutObj.changeCol = col == null ? "" : col;
      this.outPutObj.form = {};
      this.form_arr.forEach((e) => {
        this.outPutObj.form[e.getMsg] = e.msg;
      });
      this.$emit("outPut", this.outPutObj);
    },

    /**
     * 列标题 title 过长特殊处理
     */
    titleWidth() {
      for (var i = 0; i < this.form_arr.length; i++) {
        var title = document.getElementById(i);
        var fullStr = title.innerHTML;
        var letter = fullStr.match(/[a-z]+/i);
        if (letter != null) {
          var letterLength = parseInt(letter[0].length * 0.7);
          var judgeLength = fullStr.length - letter[0].length + letterLength;
        } else {
          judgeLength = fullStr.length;
        }
        if (judgeLength > 8) {
          title.style.width = "130px";
        } else if (judgeLength > 7) {
          title.style.width = "120px";
        } else if (judgeLength > 6) {
          title.style.width = "106px";
        }
      }
    },

    /**
     * 列偏移，24等份基准宽度为 4.166%
     */
    colOffset() {
      for (var j = 0; j < this.form_arr.length; j++) {
        let col = document.getElementById(j + this.form_arr.length);
        if (
          this.form_arr[j].type.o != null ||
          this.form_arr[j].type.o != undefined
        ) {
          this.form_arr[j].type.o < -2 ? -2 : this.form_arr[j].type.o;
          this.form_arr[j].type.o > 2 ? 2 : this.form_arr[j].type.o;
          if (this.form_arr[j].type.o > 0) {
            col.style.paddingRight = `${this.form_arr[j].type.o * 4.166}%`;
          } else {
            col.style.paddingLeft = `${this.form_arr[j].type.o * 4.166 * -1}%`;
          }
        } else {
          continue;
        }
      }
    },

    /**
     * 列宽度，24等份基准宽度为 4.166%
     */
    colSpan() {
      for (var j = 0; j < this.form_arr.length; j++) {
        let col = document.getElementById(j + this.form_arr.length);
        if (
          this.form_arr[j].type.s != null ||
          this.form_arr[j].type.s != undefined
        ) {
          this.form_arr[j].type.s < 0 ? 0 : this.form_arr[j].type.s;
          this.form_arr[j].type.s > 24 ? 24 : this.form_arr[j].type.s;
          col.style.width = `${this.form_arr[j].type.s * 4.166}%`;
        } else {
          col.style.width = `${8 * 4.166}%`; // 默认列宽每行三等份
        }
      }
    },
  },
  computed: {
    message_listFn() {
      return this.message_list;
    },
    form_arrFn() {
      return this.form_arr;
    },
  },
  watch: {
    /**
     * 初始数据获取
     */
    message_listFn: {
      handler(newV) {
        this.messageList = newV;
        this.form_arr.forEach((e) => {
          e.msg = this.messageList[e.getMsg];
        });
      },
      deep: true, // 引用类型 props 深度监听
    },

    form_arrFn: {
      handler(newV) {
        this.titleWidth();
        this.colOffset();
        this.colSpan();
        this.outPutFnc();
      },
      deep: true, // 引用类型 props 深度监听
    },
  },
  props: {
    /**
     * 遍历源数据，配置表
     * title: 列标题展示
     * msg: 数据双向绑定
     * getMsg: message_list 的属性名，用于初始数据获取
     * type.t: 0- span, 1- el-input, 2- el-select, 3- el-data-picker
     * type.d: disabled 属性状态
     * type.n: 必填项标红 '*' 的显示控制
     * type.o: 正数 marginRight 左偏移；负数 marginLeft 右偏移
     * type.s: span 每格占用当前行宽度
     */
    form_arr: Array,
    message_list: Object, // 接口返回初始数据
    option_list: Object, // 下拉框选项集合对象
  },
  created() {},
  mounted() {
    this.titleWidth();
    this.colOffset();
    this.colSpan();
    this.outPutFnc();
  },
};
</script>

<style scoped>
.imghover:hover {
  transform: scale(0.01);
  transition: 0.3s all;
  -webkit-transform: scale(1.19);
  cursor: pointer;
}
.imghover {
  width: 21px;
  height: 21px;
  padding-top: 10px;
  padding-left: 5px;
}

.basicMessageBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.basicMessageBox > div {
  display: flex;
  justify-content: left;
}

.basicMessageBox > div > .spanTitle {
  width: 90px;
  white-space: nowrap;
  line-height: 40px;
}

.basicMessageBox > div > .necessary {
  width: 18px;
  line-height: 40px;
  text-align: right;
  padding-right: 2px;
}

.basicMessageBox > div > .spanMsg {
  white-space: wrap;
  line-height: 40px;
}

.basicMessageBox > div > .el-input {
  width: 60%;
  line-height: 40px;
}

.basicMessageBox > div > .el-select {
  width: 60%;
  line-height: 40px;
}

.basicMessageBox > div > .el-date-picker {
  width: 60%;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/globalComponents/CcFormDisplayModify.vue